$(document).ready(function(){
var get_console = window.location.href;

  $(".ddl-select").each(function () {
    $(this).hide();
    var $select = $(this);
    var _id = $(this).attr("id");
    var wrapper = document.createElement("div");
    wrapper.setAttribute("class", "ddl ddl_" + _id);

    var input = document.createElement("input");
    input.setAttribute("type", "text");
    input.setAttribute("class", "ddl-input");
    input.setAttribute("id", "ddl_" + _id);
    input.setAttribute("readonly", "readonly");
    input.setAttribute(
      "placeholder",
      $(this)[0].options[$(this)[0].selectedIndex].innerText
    );
    

    $(this).before(wrapper);
    var $ddl = $(".ddl_" + _id);
    $ddl.append(input);
    $ddl.append("<div class='ddl-options ddl-options-" + _id + "'></div>");
    var $ddl_input = $("#ddl_" + _id);
    var $ops_list = $(".ddl-options-" + _id);
    var $ops = $(this)[0].options;
    for (var i = 0; i < $ops.length; i++) {
      $ops_list.append(
        "<div data-value='" +
          $ops[i].value +
          "'>" +
          $ops[i].innerText +
          "</div>"
      );
    }

    $ddl_input.click(function () {
      $(".ddl-options.ddl-options-sort-by").toggle();
      $ddl.toggleClass("active");
    });
    $ddl_input.blur(function () {
      $ddl.removeClass("active");
    });
    $ops_list.find("div").click(function () {
      $select.val($(this).data("value")).trigger("change");
      $ddl_input.val($(this).text().trim());
      $ddl.removeClass("active");
      $(".ddl-options.ddl-options-sort-by").hide();
      $("#sort-by").val($(this).attr("data-value")).trigger('change');
    });
  });
  $(".ddl-options.ddl-options-sort-by").hide();
  var get_currenty = window.location.href;
  if(get_currenty.includes('sort_by=')){
  var get_last = get_currenty.split('sort_by=').pop();
    // $(".ddl-options.ddl-options-sort-by div[data-value="+get_last+"]").trigger('click');
    const params = new URLSearchParams(get_console.split('?')[1]);
    const sortByValue = params.get('sort_by');
    setTimeout(function(){
      $(".ddl-options.ddl-options-sort-by div").each(function(){
        let dateAttr = $(this).attr("data-value");
        if(dateAttr == sortByValue){
          let vals = $(this).text().trim();
          $(".sort-by--container").find("input").attr("placeholder",vals);
           const input = document.querySelector("input#ddl_sort-by");
           updateData(input);
        }
      });
    },2000);
  }



$(document).on("change","#sort-by",function(e){
  e.preventDefault();
  let page_url = window.location.pathname;
  var get_url = window.location.href;
  if(get_url.includes('?page')){
    var get_split = get_url.split('?').pop();
    var get_query = get_split.split('&')[0];
    var sort_style = e.currentTarget.value;
    $('#sort-by').attr('data',sort_style);
    var main_page_url = page_url+"?"+get_query+"&sort_by="+sort_style;
  }else{
    var sort_style = e.currentTarget.value;
    $('#sort-by').attr('data',sort_style);
    var main_page_url = page_url+"?sort_by="+sort_style;
  }
  window.history.pushState({}, '', main_page_url);
  var get_window = window.location.pathname;

  $.ajax({
    type: "GET",
    url: main_page_url,
    cache: false,
    success: function(data){ 
        $('ul.list--inline.pagination').html($(data).find('ul.list--inline.pagination').html());
    }
  });

  $.ajax({
    type: "GET",
    url: main_page_url,
    cache: false,
    success: function(data){ 
        var tempDiv = $('<div>').html(data);

      var productsContent = tempDiv.find('.collection-products').html();

      $('.collection-products').html(productsContent);
      window.location.reload(true);
    }
  });
}); 

$(".js-collection-template-see").click(function(){
  setTimeout(function(){
    var data_val = $("select#sort-by option:selected").trigger("change");
  },100);
});

$("#sort-by").click(function(e){ 
  $("#sort-by option:first").hide();
  $(this).addClass("active-selectbox");
});
$(document).on("click", function(e) {
  if ($(e.target).is("#sort-by") === false) {
    $("#sort-by").removeClass("active-selectbox");
  }
});
  
var radioValue = $(".product-card__variant-swatches .input-container input:checked").next().attr('var_img');
$('.variant-image .product-single__image').attr('data-href',radioValue);
  
$(document).on('click','.product-card__variant-swatches .input-container input',function(){
    var selectedValue = $(this).next().attr('var_img');
    $('.variant-image .product-single__image').attr('data-href',selectedValue);
  $('.variant-image .product-single__image').trigger('zoom.destroy'); 
});
if ($(window).width() > 767) {

$("body").on('click', '.withoutvar', function() {
  if($(this).find("img").hasClass("zoomImg")){
    $( this ).trigger('zoom.destroy'); 
  }else{
    var href = $(this).attr("data-href");
    if(href){
      $(this).zoom({url: href});
    }
  }
});

$("body").on('click', '.variant-image .product-single__image', function() {
  if($(this).find("img.imagezoom").hasClass("zoomImg")){
    console.log('in if');
    $( this ).trigger('zoom.destroy'); 
    $('.zoomImg').remove();
  }else{
    var href = $(this).attr("data-href");
    console.log('in else');
    if(href){
      $(this).zoom({url: href});
    }
  }
});

}

$('.list_swatches1').each(function(){
  var possibles2   = []; 
  var option1 = $(this).find('input:checked').val();
  var option2 = $(this).next('.list_swatches2').find('input:checked').val();
  var combination2 = option1 +' / '+ option2;
  $(this).parents('.product-card-v2__variant-swatches').find(".jsproduct-select option").each(function(){
    var option_value = $(this).text().trim();
    if(option_value.includes(option1)){
      possibles2.push(option_value)
    }
  });
  var test = '';
  $(this).next('.list_swatches2').find('input').each(function(){
    var option2_flag=false;
    var option2_val = $(this).val();
    possibles2.forEach((variant) => {
      if (variant.includes(option2_val)) {
        option2_flag=true;
      }
      
    })
    if(option2_flag === false) {
      $(this).hide();
      $(this).next().hide();
    }else{
      $(this).show();
      $(this).next().show();
    }
  })
});


$('.list_swatches1 label').on('click',function(){
   var possibles2   = []; 
   var selectedVal = [];
   var option1 = $(this).prev().val();
   var option2 = $(this).parents('.list_swatches1').next('.list_swatches2').find('input:checked').val();
   var combination2 = option1 +' / '+ option2;
   $(this).parents('.product-card-v2__variant-swatches').find(".jsproduct-select option").each(function(){
      var option_value = $(this).text().trim();
      if(option_value.includes(option1)){
        possibles2.push(option_value)
      }
   });
    var test = '';
    $(this).parents('.list_swatches1').next('.list_swatches2').find('input').each(function(){
      var option2_flag=false;
      var option2_val = $(this).val();
      possibles2.forEach((variant) => {
        if (variant.includes(option2_val)) {
          option2_flag=true;
        }
        
      })
      if(option2_flag === false) {
        $(this).hide();
        $(this).next().removeClass('avail').hide();
      }else{
        
		
        $(this).show();
        $(this).next().addClass('avail').show();
        var firstVal = $(this).val();
        selectedVal.push(firstVal);
		var firstValue = selectedVal[0];
        var attr = $(this).attr('value');
        if (attr == firstValue) {
           $(this).click();
            }
        
      }
		
    })
    
  });
  if ($("header").hasClass("make_background_white")) {
    $("body").addClass("header_has_bg");
  }

setTimeout(function(){
  const input = document.querySelector("input#ddl_sort-by");
  
  document.querySelectorAll(".ddl-options.ddl-options-sort-by div").forEach((box)=>{
    box.addEventListener("click", function() {
      updateData(box);
    });
  });
  updateData(input);
}, 500);

function updateData(box){
  const tagName = box.tagName;   
  let inputText = box.textContent.trim();

  if (tagName === 'INPUT') {         
    inputText = box.value.trim() || box.placeholder || "Default";         
  }
  const input = document.querySelector("input#ddl_sort-by");
  const style = window.getComputedStyle(input);
  const font = style.fontSize + " " + style.fontFamily;
  const paddingLeft = parseFloat(style.paddingLeft);
  const paddingRight = parseFloat(style.paddingRight);
  const borderLeft = parseFloat(style.borderLeftWidth);
  const borderRight = parseFloat(style.borderRightWidth);
  const boxSizing = style.boxSizing;
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context.font = font;

  let textWidth = context.measureText(inputText).width;
  let totalWidth = textWidth;
  if(boxSizing === 'content-box'){
    totalWidth += paddingLeft + paddingRight + borderLeft + borderRight;
  }
  totalWidth += 10;
  input.style.maxWidth = Math.ceil(totalWidth) + "%";
}

});

function slider_init_cart_drawer(){
var get_speed = $(".trans_speed").val();
    mySwiper =  new Swiper('.main_slider_div', {
        loop: true,
        slidesPerView: 1,
autoplay: {
    delay: get_speed,
  },
        paginationClickable: true,
        spaceBetween: 20,
   
    });
}
function cart_messages(){

var get_gift = $(".gift_price_minicart").val();
var get_percentage = $(".percentage_off").val();
var get_free_shipping_text = $(".free_shipping_text").val();
var two_items_text = $(".two_items_text").val();
var get_gift_before_text = $(".gift_text1").val();
var text_after = $(".text_after").val();
var one_more_text = $(".one_more_text").val();
  jQuery.ajax({
    type: 'GET',
    url: '/cart',
    dataType: 'json',
    success: function(cartnew){ 
      var get_price2 = cartnew.total_price;
      var get_price = get_price2 * 1;
if (typeof get_price === "undefined") {
    // ...
    }else{
        if(get_price > 0){
        var get_length = $(".free_shipping_wrapper").length;
          if(get_length == 0 ){
     $(".cart-header").append('<div class="gift-product__message free_shipping_wrapper swiper-slide">'+get_free_shipping_text+'</div>');

          }
    }else{
      $(".free_shipping_wrapper").remove();
     }
     if(get_price <= get_gift){
var get_length2 = $(".free_gift_wrapper").length;
          if(get_length2 == 0 ){
     $(".cart-header").append('<div class="gift-product__message text_before_gift free_gift_wrapper swiper-slide">'+get_gift_before_text+'</div>');

          }else if(get_length2 > 0){
   $(".free_gift_wrapper").removeClass('text_after_wrapper');
          $(".free_gift_wrapper").addClass('text_before_gift');
            $(".free_gift_wrapper").text(get_gift_before_text);

            }
    }else{
        var get_length4 = $(".free_gift_wrapper").length;
          if(get_length4 == 0 ){
     $(".cart-header").append('<div class="gift-product__message text_after_wrapper free_gift_wrapper swiper-slide">'+text_after+'</div>');

          }else if(get_length4 >  0 ){
          $(".free_gift_wrapper").removeClass('text_before_gift');
          $(".free_gift_wrapper").addClass('text_after_wrapper');

          $(".free_gift_wrapper").text(text_after);
       }
          }
        var check_exist2 = $(".main_slider_div").length;
          if(check_exist2 == 0 ){
          $('.free_shipping_wrapper,.free_gift_wrapper').wrapAll('<div class="main_slider_div swiper-container"><div class="swiper-wrapper"></div></div>');  
           // $(".main_slider_div").append('<div class="swiper-button-prev"></div> <div class="swiper-button-next"></div>')

            }

    if(get_price > get_gift && get_price <= get_percentage ){
var get_length3 = $(".get_offer").length;
          if(get_length3 == 0 ){
         // $('<div class="get_offer">Get 15% off on your order of $150+</div>').append(".main_slider_div");
          $(".main_slider_div .swiper-wrapper").append('<div class="gift-product__message before_percent_text get_offer swiper-slide">'+two_items_text+'</div>');
          }else if(get_length3 > 0 ){
      $(".get_offer").removeClass('text_after_percent');
              $(".get_offer").addClass('before_percent_text');
              $(".get_offer").text(two_items_text);
    }
      }else if(get_price > get_percentage){
     var get_length5 = $(".get_offer").length;
          if(get_length5 == 0 ){
         // $('<div class="get_offer">Congrats !! you have unlocked 15% off</div>').append(".cart-body");
          $(".main_slider_div .swiper-wrapper").append('<div class="gift-product__message text_after_percent get_offer swiper-slide">'+one_more_text+'</div>');

          }else if(get_length5 > 0  ){
              $(".get_offer").removeClass('before_percent_text');
              $(".get_offer").addClass('text_after_percent');

      $(".get_offer").text(one_more_text);
         }


      }else{
      $(".get_offer").remove();
    }
      if($(".main_slider_div").hasClass('swiper-container-initialized')){

   mySwiper.destroy( true, true );
      slider_init_cart_drawer();
      }else{
      slider_init_cart_drawer();

       }
  

    }

    }
  });
 

}
$(document).on("change","#sort-by",function(e){ 
e.preventDefault();
let page_url = window.location.pathname;
var get_url = window.location.href;
var sort_style = e.currentTarget.value;
if(sort_style == 'best-selling' || sort_style == 'created-descending') {
if(get_url.includes('?page')){
var get_split = get_url.split('?').pop();
var get_query = get_split.split('&')[0];
var sort_style = e.currentTarget.value;
$('#sort-by').attr('data',sort_style);
 var main_page_url = page_url+"?"+get_query+"&sort_by="+sort_style;
}else{
var sort_style = e.currentTarget.value;
console.log(sort_style);
$('#sort-by').attr('data',sort_style);
 var main_page_url = page_url+"?sort_by="+sort_style;
}
 window.history.pushState({}, '', main_page_url);

var get_window = window.location.pathname;
 $.ajax({
  type: "GET",
  url: main_page_url,
  cache: false,
  success: function(data){ 

  var tempDiv = $('<div>').html(data);
    var productsContent = tempDiv.find('.collection-products').html();
    $('.collection-products').html(productsContent);
    window.location.reload(true);
}
});
}
});